import React, { ReactNode, useState } from 'react';
import { Tooltip } from 'react-tippy';
import clsx from 'clsx';
import './styles.scss';

interface IOwnProps {
  type?: Nullable<string>;
  tooltipText: string;
  children: Nullable<ReactNode>;
}

const RowCell = (props: {
  children: Nullable<ReactNode>;
  sticky?: boolean;
}) => (
  <div
    data-testid="table-row-cell"
    styleName={`${props.sticky ? 'normal sticky' : 'normal'}`}
  >
    {props.children}&nbsp;
  </div>
);

const RowCellTooltip = (props: IOwnProps) => {
  const { type, tooltipText, children } = props;
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const setIsOpen = (isVisible: boolean) => {
    setIsVisible(isVisible);
  };

  const onMouseEnter = () => {
    setIsOpen(true);
  };

  const onMouseLeave = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const el of document.querySelectorAll('.tippy-popper')) {
      el.remove();
    }
    setIsOpen(false);
  };

  const customStyle = clsx({
    normal: true,
    warning: type === 'warning',
    danger: type === 'danger',
  });

  return (
    <div
      styleName={customStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Tooltip
        distance={15}
        disabled={!isVisible}
        open
        animation="none"
        duration={0}
        position="top"
        arrow
        title={tooltipText}
      >
        {children}
      </Tooltip>
      &nbsp;
    </div>
  );
};

export { RowCell, RowCellTooltip };
